import { Options, Splide, SplideTrack } from '@splidejs/react-splide';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import '@splidejs/react-splide/css';
import SliderArrow from './SliderArrow';

type SliderProps = {
  settings: Options,
  classNames: {
    [x: string]: string,
  },
  children: React.ReactNode,
  onMove?: (slideIndex: number) => void;
};

const Slider = forwardRef<Splide, SliderProps>(({
  settings, classNames, children, onMove,
}, ref) => (
  <Splide
    hasTrack={false}
    options={settings}
    className={classNames.slider}
    onMove={e => onMove?.(e.index)}
    ref={ref}
  >
    <SplideTrack
      className={classNames.track}
    >
      {children}
    </SplideTrack>
    {settings.arrows && (
    <div className={classnames(classNames.navigation, 'splide__arrows')}>
      <SliderArrow
        type='prev'
        className={classnames(classNames.arrow, classNames.prevArrow)}
      />
      <SliderArrow
        type='next'
        className={classnames(classNames.arrow, classNames.nextArrow)}
      />
      {/* <button
            type='button'
            className={classnames('splide__arrow splide__arrow--prev', classNames.arrow, classNames.prevArrow)}
          >
            <Img
              src={`/media/slider-arrow-right-${appTheme}.svg`}
              alt='slider arrow right'
            />
          </button>
          <button
            type='button'
            className={classnames('splide__arrow splide__arrow--next', classNames.arrow, classNames.nextArrow)}
          >
            <Img
              src={`/media/slider-arrow-right-${appTheme}.svg`}
              alt='slider arrow right'
            />
          </button> */}
    </div>
    )}
  </Splide>
));

export default Slider;
